import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss'
import * as classNames from 'classnames';
import stylesheet, { directions } from 'src/Constants/stylesheet';
import spacing from 'src/Constants/spacing';
import responsive from 'src/Constants/responsive';
import Accordion from './Accordion';
import closeIcon from 'src/assets/icons/Close.svg';
import Diaporama from './Diaporama';
import { Link } from 'react-router-dom';
import fonts from 'src/Constants/fonts';

export type ProjectProps = {
    project: ProjectDto;
    isMobile: boolean;
};

const styles = {
    container: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden'
    },
    textContainer: {
        position: 'relative',
        flex: '0 0 auto',
        height: 115,
        zIndex: 1
    },
    previewText: {
        [responsive.Mobile]:
        {
            margin: `0 ${spacing.Gutter.Mobile}px`,
            paddingTop: spacing.ContentGutter.Mobile,
        },
        [responsive.AfterMobile]:
        {
            margin: `0 ${spacing.Gutter.Desktop}px`,
            paddingTop: spacing.ContentGutter.Desktop,
            paddingLeft: 175 - (spacing.Gutter.Desktop)
        }
    },
    previewTextInner: {
        [responsive.AfterMobile]:
        {
            maxWidth: spacing.MaxWidthText,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    containerText: {
        display: 'none',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1,
        pointerEvents: 'none',
        [responsive.Mobile]:
        {
            paddingTop: spacing.ContentGutter.Mobile
        },
        [responsive.AfterMobile]:
        {
            paddingTop: spacing.ContentGutter.Desktop
        }
    },
    containerTextShow: {
        display: 'block',
    },
    scrollinContainer: {
        position: 'relative',
        maxHeight: "100%",
        overflow: 'auto',
        overflowScrolling: 'touch',
        background: 'white',
        pointerEvents: 'initial'
    },
    contentText: {
        maxWidth: spacing.MaxWidthText,
        [responsive.Mobile]:
        {
            margin: `0 ${spacing.Gutter.Mobile}px`,
            paddingBottom: spacing.paddingBottomSpace.Mobile
        },
        [responsive.AfterMobile]:
        {
            marginLeft: 175,
            paddingBottom: spacing.paddingBottomSpace.Desktop
        }
    },
    preview: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',

    },
    imagesContainer: {
        marginTop: 'auto',
        ...stylesheet.MarginGutter(1, directions.sides)
    },
    images: {
        position: 'relative',
        overflow: 'hidden',
        height: 0,
        zIndex: 0,
        [responsive.Mobile]: {
            paddingBottom: '100%'
        },
        [responsive.MobileHorizontal]: {
            paddingBottom: '30%'
        },
        [responsive.Laptop]: {
            paddingBottom: '50%'
        },
        [responsive.Desktop]: {
            paddingBottom: '40%'
        }
    },
    imagesBottom: {
        ...stylesheet.MarginGutter(1, directions.bottom)
    },
    imagesInner: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    },
    introText: {
        [responsive.Mobile]: {
            marginBottom: spacing.ContentGutter.Mobile
        },
        [responsive.AfterMobile]: {
            marginBottom: spacing.ContentGutter.Desktop
        }
    },
    closeContent: {
        position: 'absolute',
        zIndex: 1,
        left: spacing.Gutter.Desktop,
        cursor: 'pointer',
        pointerEvents: 'initial',
        [responsive.Mobile]: {
            display: 'none'
        },
        [responsive.AfterMobile]: {
            top: spacing.ContentGutter.Desktop
        }
    },
    closeIcon: {
        height: 20
    },
    text: {
        '& a': {
            ...fonts.ExcelsiorLTItalic
        }
    },
    relatedOuter: {},
    relatedLink: {},
    projectAccordion: {
        [responsive.Mobile]: {
            paddingBottom: 49
        },
        [responsive.AfterMobile]: {
            paddingBottom: 49
        }
    }
}
type Props =
    ProjectProps &
    StyledComponentProps<keyof typeof styles>;

type State = {
    contentOpen: boolean;
    isMouseHover: boolean;
    relatedOpen: boolean;
    notesOpen: boolean;
};

class Project extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);

        this._openContent = this._openContent.bind(this);
        this._closeContent = this._closeContent.bind(this);
        this._toggleContentMobile = this._toggleContentMobile.bind(this);
        this._toggleRelated = this._toggleRelated.bind(this);
        this._toggleNotes = this._toggleNotes.bind(this);
        this._onHover = this._onHover.bind(this);
        this._onLeave = this._onLeave.bind(this);
        this._isMobile = this._isMobile.bind(this);

        this.state = {
            contentOpen: false,
            isMouseHover: false,
            relatedOpen: false,
            notesOpen: false,
        }
    }
    public render() {
        const { classes, isMobile,
            project: { Images, IntroText, Text, PreviewText, Related,
                 OpenRelated, OpenNotes, CloseNotes, CloseRelated } } = this.props;
        const { isMouseHover, contentOpen, relatedOpen, notesOpen } = this.state;

        return (
            <div className={classNames(classes!.container)}>
                <div className={classes!.textContainer}>
                    <div
                        className={classes!.previewText}
                    >
                        <div
                            className={classes!.previewTextInner}
                            onMouseEnter={() => this._onHover()}
                            onMouseLeave={() => this._onLeave()}
                            onClick={(e) => this._toggleContentMobile(e)}
                        >
                            {PreviewText}
                        </div>
                    </div>
                </div>
                <div
                    className={classNames(classes!.containerText,
                        isMouseHover ? classes!.containerTextShow : '',
                        contentOpen ? classes!.containerTextShow : '')}
                >
                    {contentOpen && <a
                        className={classes!.closeContent}
                        onClick={(e) => this._closeContent(e)}
                    >
                        <img src={closeIcon} alt="close icon" className={classes!.closeIcon} />
                    </a>
                    }
                    <div
                        className={classes!.scrollinContainer}
                    >
                        <div className={classes!.contentText}>
                            <div
                                onMouseEnter={() => this._onHover()}
                                onMouseLeave={() => this._onLeave()}
                                onClick={(e) => {
                                    if (isMobile) {
                                        this._toggleContentMobile(e)
                                    } else {
                                        this._openContent(e)
                                    }
                                }}
                            >
                                <div
                                    className={classes!.introText}
                                    dangerouslySetInnerHTML={{ __html: IntroText }} />

                                {Related.length > 0 &&
                                    <Accordion
                                        openLegend={OpenRelated}
                                        closeLegend={CloseRelated}
                                        related={true}
                                        isOpen={relatedOpen}
                                        toggle={this._toggleRelated}
                                    >
                                        {Related.map(r =>
                                            <div
                                                key={r.UID}
                                                className={classes!.relatedOuter}
                                            >
                                                <Link
                                                    to={r.URL}
                                                    className={classes!.relatedLink}
                                                >
                                                    — {r.Title}
                                                </Link>
                                            </div>
                                        )}
                                    </Accordion>
                                }

                                {Text.length > 0 &&
                                    <Accordion
                                        openLegend={OpenNotes}
                                        closeLegend={CloseNotes}
                                        related={false}
                                        isOpen={notesOpen}
                                        toggle={this._toggleNotes}
                                    >
                                        <div className={classes!.text} dangerouslySetInnerHTML={{ __html: Text }} />
                                    </Accordion>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className={classes!.imagesContainer}>
                    <div className={classNames(classes!.images, classes!.imagesBottom)}>
                        <div className={classes!.imagesInner}>
                            <Diaporama images={Images} />
                        </div>
                    </div>
                </div>
            </div >
        );
    }

    private _isMobile() {
        const body = document.body;
        if (!body) { return }

        return body.clientWidth <= 600;
    }

    private _onHover() {
        const { project: { IntroText } } = this.props;
        const { contentOpen } = this.state;
        const isMobile = this._isMobile();

        if (contentOpen || isMobile || IntroText.length <= 0) { return }
        this.setState({ isMouseHover: true });
    }

    private _onLeave() {
        const { project: { IntroText } } = this.props;
        const { contentOpen } = this.state;
        const isMobile = this._isMobile();

        if (contentOpen || isMobile || IntroText.length <= 0) { return }
        this.setState({ isMouseHover: false });
    }

    private _openContent(e: React.MouseEvent<HTMLDivElement>) {
        e.preventDefault();
        e.stopPropagation();
        this.setState(prev => ({ contentOpen: true, isMouseHover: false }))
    }
    private _closeContent(e: React.MouseEvent<HTMLAnchorElement>) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ 
            contentOpen: false, 
            isMouseHover: false,
            notesOpen: false,
            relatedOpen: false,
         })
    }

    private _toggleContentMobile(e: React.MouseEvent<HTMLDivElement>) {
        const { isMobile } = this.props;

        e.preventDefault();
        e.stopPropagation();

        if (!isMobile) { return }
        this.setState(prev => ({ contentOpen: !prev.contentOpen, isMouseHover: false }))
    }

    private _toggleRelated(e: React.MouseEvent<HTMLAnchorElement>) {
        e.preventDefault();
        e.stopPropagation();
        this.setState(prev => ({ relatedOpen: !prev.relatedOpen }));
    }

    private _toggleNotes(e: React.MouseEvent<HTMLAnchorElement>) {
        e.preventDefault();
        e.stopPropagation();
        this.setState(prev => ({ notesOpen: !prev.notesOpen }));
    }
}

export default withStyles(styles)(Project);


// WEBPACK FOOTER //
// ./src/Components/Project.tsx